import ndsTokens from 'nicollet-tokens';
import styled from 'styled-components';

const IconButtonStyles = styled.button`
  display: flex;
  padding: 0;
  margin: 0;
  background: none;
  color: inherit;
  border: none;
  cursor: pointer;

  :focus {
    color: ${ndsTokens.colors.palette.gray.dark};
    outline: ${ndsTokens.colors.border.focusOutline} dashed 1px;
    -moz-outline-radius: 4px;
    text-decoration: none;
  }
`;

export { IconButtonStyles };
